module.exports = __webpack_public_path__ + "63f3d23aee4a5d26f41532303fb217a2.png";